import { molecule } from 'bunshi';

import { appointmentMolecule } from '../appointmentMolecule';
import { SessionScope } from '../scopes';

/**
 * Session Molecule
 *
 * Provides all appointment-related atoms scoped to a session (keyed by roomId).
 * This molecule is automatically created and destroyed when entering/leaving a session.
 *
 * Depends on appointmentMolecule (via DailyRoomNameScope) for appointment data,
 * and SessionScope for in-session isolation.
 *
 * The atoms within this molecule:
 * - `appointmentQueryAtom`: Fetches appointment data by roomId
 * - `appointmentAtom`: Derived from query result
 * - `patientIdAtom`: Extracted from appointment.client_id
 * - `providerIdAtom`: Extracted from appointment.provider_id
 * - `healthieAppointmentAtom`: Extracted from appointment.healthie
 * - `healthieAppointmentIdAtom`: Extracted from appointment.healthie_id
 */
export const sessionMolecule = molecule((mol, scope) => {
  scope(SessionScope);

  const {
    appointmentQueryAtom,
    appointmentAtom,
    patientIdAtom,
    providerIdAtom,
    healthieAppointmentAtom,
    healthieAppointmentIdAtom,
  } = mol(appointmentMolecule);

  return {
    appointmentQueryAtom,
    appointmentAtom,
    patientIdAtom,
    providerIdAtom,
    healthieAppointmentAtom,
    healthieAppointmentIdAtom,
  };
});
